export default __webpack_public_path__ + "static/media/IconWebsite.019ca875.svg";